import { NgModule, LOCALE_ID } from '@angular/core';
import { SharedModule } from '../shared/shared.module';
import { ProductRoutingModule } from './product-routing.module';
import { ProductService } from './product.service';
import { SupplierDetailPageComponent } from './supplier-detail-page.container';
import { SupplierListPageComponent } from './supplier-list-page.container';
import { SupplierService } from './supplier.service';
import { SupplierListComponent } from './supplier-list/supplier-list.component';
import { SupplierFormComponent } from './supplier-form/supplier-form.component';
import {SimpleTravelListComponent} from './simple-travel-list/simple-travel-list.component';
import {SimpleTravelFormComponent} from './simple-travel-form/simple-travel-form.component';
import {SimpleTravelListPageComponent} from './simple-travel-list-page.container';
import {SimpleTravelDetailPageComponent} from './simple-travel-detail-page.container';
import {SimpleTravelService} from './simple-travel.service';
import { SimpleTravelFormRoomTypeComponent } from './simple-travel-form-room-types/simple-travel-form-room-types.component';
import { SimpleTravelFormAirportsComponent } from './simple-travel-form-airports/simple-travel-form-airports.component';
import { SimpleTravelFormBoardUpgradesComponent } from './simple-travel-form-board-upgrades/simple-travel-form-board-upgrades.component';

import { CommonModule } from '@angular/common';
import { NoopAnimationsModule, BrowserAnimationsModule } from '@angular/platform-browser/animations';


import { NgxMyDatePickerModule } from 'ngx-mydatepicker';

import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import { AngularLoadingBarModule } from 'ng4-loader-bar';
import { TranslateModule } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

import { OrderModule } from 'ngx-order-pipe';

import {ImageCropperModule} from 'ng2-img-cropper';
import { CurrencyMaskModule } from "ng2-currency-mask";


// ,     BrowserAnimationsModule
export function HttpLoaderFactory(httpClient: HttpClient) {
  return new TranslateHttpLoader(httpClient, '../../assets/i18n', '.json');
}


@NgModule({
  declarations: [
    SimpleTravelListComponent,
    SimpleTravelFormComponent,
    SimpleTravelListPageComponent, SimpleTravelDetailPageComponent,
    SupplierDetailPageComponent, SupplierListPageComponent,
    SupplierListComponent, SupplierFormComponent, SimpleTravelFormRoomTypeComponent, SimpleTravelFormAirportsComponent,
    SimpleTravelFormBoardUpgradesComponent
  ],
  imports: [SharedModule, ProductRoutingModule,
    NgbModule, AngularLoadingBarModule.forRoot(), TranslateModule.forRoot(), NgxMyDatePickerModule.forRoot(),
     OrderModule, ImageCropperModule,CurrencyMaskModule

  ],
  providers: [ProductService, SimpleTravelService, SupplierService, { provide: LOCALE_ID, useValue: 'de-DE'}]
})
export class ProductModule {}



// WEBPACK FOOTER //
// ./src/app/product/product.module.ts